module.exports = __webpack_public_path__ + "img/38.3ae4bd8f.jpg";